import * as React from "react";

import "./unenroll-modal.scss";

import {bindInput}     from "@Common/react/bind-input";
import {cs}            from "@Common/react/chain-services";
import {Trimmer}       from "@Common/react/trimmer";
import {UseState}      from "@Common/react/use-state";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const UnenrollModal = ({program, next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3({
        // xToClose: false,
        xdQaName: "Unenroll confirmation modal",
        title: `Unenroll from ${program?.programPreferences?.linkName} Program?`,
        width: 500,
        next,
        rootNext,
    })],
    ["reason", (_, next) => UseState({next})],
    ({modal, reason}) => (
        <div className="unenroll-modal-7ig">
            <div className="content">
                <div {...{
                    className: "message",

                    "xd-qa-type": "text",
                    "xd-qa-name": "Unenroll message",
                }}>
                    Are you sure you want to unenroll from the <b>{program?.programPreferences?.linkName}</b> program?{" "}
                    By doing so, you will withdraw from the program entirely.{" "}
                    This means your participation in any current and future Editions will be cancelled.{" "}
                    Are you sure you want to unenroll?
                </div>

                <div className="reason">
                    <div className="title">
                        Reason:
                    </div>

                    {cs(
                        ["buffer", (_, next) => Trimmer({state: reason, next})],
                        ({buffer}) => (
                            <textarea {...{
                                ...bindInput(buffer.state),
                                onBlur: buffer.flush,
                                "xd-qa-type": "textarea",
                                "xd-qa-name": "Reason",
                            }}/>
                        ),
                    )}
                </div>
            </div>
            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: () => modal.close(null),
                    "xd-qa-type": "button",
                    "xd-qa-name": "Cancel",
                }}>
                    Cancel
                </button>
                <button {...{
                    className: "next",
                    onClick: () => modal.close({reason: reason.value}),
                    disabled: !reason.value,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Unenroll",
                }}>
                    Unenroll
                </button>
            </div>
        </div>
    )
);
